/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCycleSubjectDto } from '../../models/amoxcalli-cycle-subject-dto';

export interface ApiCycleSubjectsGet$Json$Params {
  cycleId?: string;
  gradeId?: string;
}

export function apiCycleSubjectsGet$Json(http: HttpClient, rootUrl: string, params?: ApiCycleSubjectsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliCycleSubjectDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCycleSubjectsGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleId', params.cycleId, {});
    rb.query('gradeId', params.gradeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliCycleSubjectDto>>;
    })
  );
}

apiCycleSubjectsGet$Json.PATH = '/api/cycle-subjects';
